import { createFileRoute, Link, Outlet } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import { camps } from '~/data/camps';
import { langStore } from '~/store/langStore';
import { cn } from '~/utils';

export const Route = createFileRoute('/camps')({
  component: CampsLayout,
});

function CampsLayout() {
  const locale = useStore(langStore, s => s);
  return (
    <div className="mx-auto flex w-[90%] flex-col gap-8 px-4 py-24 md:w-2/3 lg:flex-row">

      <div className="flex w-full flex-row justify-around lg:w-1/4 lg:flex-col lg:justify-start">
        <div className="w-full border border-orange">
          {camps.map(camp => (
            <Link
              key={camp.slug}
              to="/camps/$campSlug"
              params={{ campSlug: camp.slug }}
              className={cn(
                'text-md block px-6 py-4 font-bold text-orange transition-colors hover:bg-orange hover:text-white lg:text-lg',
                '[&.active]:bg-orange [&.active]:text-white',
              )}
            >
              {camp.title[locale] || camp.title.HU}
            </Link>
          ))}
        </div>
      </div>

      {/* Content Area */}
      <div className="min-h-screen w-full lg:w-3/4">
        <div className="border border-orange p-4 lg:p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
